import { render, staticRenderFns } from "./PaymentServicesStatement.vue?vue&type=template&id=35f84170"
import script from "./PaymentServicesStatement.vue?vue&type=script&lang=js"
export * from "./PaymentServicesStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports